/** @deprecated use `cn` from `@/lib/helpers/cn` instead. */
export function createClassNameString(classNameArray) {
  return classNameArray.filter((className) => !!className).join(" ");
}
